<style>
.table-dashboard thead tr td {
    background: #1f2248;
    color: #fff;
}
</style>
<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Laporan Status">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_dari"
                            required
                            label="Dari"
                            type="date"
                        />
                        <!-- <z-lookup
                            label="Akaun"
                            :url="service_bil_pelbagai + 'lookup/akaun_inbois'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.akaun_id"
                        /> -->
                    </div>
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_hingga"
                            required
                            label="Hingga"
                            type="date"
                        />
                        <z-lookup
                            label="Cawangan"
                            :url="service_pembayaran + 'lookup/jabatan_user'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.jabatan_id"
                        />
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>

            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="14%" style="float:left;">
                        <thead>
                            <tr>
                                <td colspan="2" style="text-align:center;">Draf</td>
                            </tr>
                            <tr>
                                <td style="text-align:center;">Bil</td>
                                <td style="text-align:center;">Amaun (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dt, index) in table.draf_items">
                                <td>{{ dt.no }}</td>
                                <td style="text-align:right;">{{ dt.amaun }}</td>
                            </tr>
                            <tr v-for="index in table.extra_draf_rows">
                                <td>&nbsp;</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table-dashboard" width="14%" style="float:left;">
                        <thead>
                            <tr>
                                <td colspan="2" style="text-align:center;">Semakan</td>
                            </tr>
                            <tr>
                                <td style="text-align:center;">Bil</td>
                                <td style="text-align:center;">Amaun (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dt, index) in table.semakan_items">
                                <td>{{ dt.no }}</td>
                                <td style="text-align:right;">{{ dt.amaun }}</td>
                            </tr>
                            <tr v-for="index in table.extra_semakan_rows">
                                <td>&nbsp;</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table-dashboard" width="14%" style="float:left;">
                        <thead>
                            <tr>
                                <td colspan="2" style="text-align:center;">Pengesahan</td>
                            </tr>
                            <tr>
                                <td style="text-align:center;">Bil</td>
                                <td style="text-align:center;">Amaun (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dt, index) in table.pengesahan_items">
                                <td>{{ dt.no }}</td>
                                <td style="text-align:right;">{{ dt.amaun }}</td>
                            </tr>
                            <tr v-for="index in table.extra_pengesahan_rows">
                                <td>&nbsp;</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table-dashboard" width="14%" style="float:left;">
                        <thead>
                            <tr>
                                <td colspan="2" style="text-align:center;">Disahkan</td>
                            </tr>
                            <tr>
                                <td style="text-align:center;">Bil</td>
                                <td style="text-align:center;">Amaun (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dt, index) in table.disahkan_items">
                                <td>{{ dt.no }}</td>
                                <td style="text-align:right;">{{ dt.amaun }}</td>
                            </tr>
                            <tr v-for="index in table.extra_disahkan_rows">
                                <td>&nbsp;</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table-dashboard" width="14%" style="float:left;">
                        <thead>
                            <tr>
                                <td colspan="2" style="text-align:center;">Semak Semula</td>
                            </tr>
                            <tr>
                                <td style="text-align:center;">Bil</td>
                                <td style="text-align:center;">Amaun (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dt, index) in table.semak_semula_items">
                                <td>{{ dt.no }}</td>
                                <td style="text-align:right;">{{ dt.amaun }}</td>
                            </tr>
                            <tr v-for="index in table.extra_semak_semula_rows">
                                <td>&nbsp;</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table-dashboard" width="14%" style="float:left;">
                        <thead>
                            <tr>
                                <td colspan="2" style="text-align:center;">Batal</td>
                            </tr>
                            <tr>
                                <td style="text-align:center;">Bil</td>
                                <td style="text-align:center;">Amaun (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dt, index) in table.batal_items">
                                <td>{{ dt.no }}</td>
                                <td style="text-align:right;">{{ dt.amaun }}</td>
                            </tr>
                            <tr v-for="index in table.extra_batal_rows">
                                <td>&nbsp;</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table-dashboard" width="14%" style="float:left;">
                        <thead>
                            <tr>
                                <td colspan="2" style="text-align:center;">Selesai</td>
                            </tr>
                            <tr>
                                <td style="text-align:center;">Bil</td>
                                <td style="text-align:center;">Amaun (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dt, index) in table.selesai_items">
                                <td>{{ dt.no }}</td>
                                <td style="text-align:right;">{{ dt.amaun }}</td>
                            </tr>
                            <tr v-for="index in table.extra_selesai_rows">
                                <td>&nbsp;</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table-dashboard" width="99%" style="float:left;">
                        <tr>
                            <td width="14%"><b>JUMLAH <span style="float:right">{{table.total_draf}}</span></b></td>
                            <td width="14%"><b> <span style="float:right">{{table.total_semakan}}</span></b></td>
                            <td width="14%"><b> <span style="float:right">{{table.total_pengesahan}}</span></b></td>
                            <td width="14%"><b> <span style="float:right">{{table.total_disahkan}}</span></b></td>
                            <td width="14%"><b> <span style="float:right">{{table.total_semak_semula}}</span></b></td>
                            <td width="14%"><b> <span style="float:right">{{table.total_batal}}</span></b></td>
                            <td width="14%"><b> <span style="float:right">{{table.total_selesai}}</span></b></td>
                        </tr>
                    </table>
                </div>
            </w-flex>

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
        auth: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_pembayaran + "laporan/status",
            reload: true,
            resit_id: null,
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/" },
                { label: "Arahan Pembayaran", route: "/bayaran/laporan/status" },
                { label: "Laporan", route: "/bayaran/laporan/status" },
                {
                    label: "Laporan Status",
                    route: "/bayaran/laporan/status",
                },
            ],
            cari: { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "" },
        };
    },
    methods: {
        search() {
            this.$inertia.visit(
                window.route("bayaran.laporan.status") +
                    "?tarikh_dari=" +
                    this.cari.tarikh_dari +
                    "&tarikh_hingga=" +
                    this.cari.tarikh_hingga +
                    "&jabatan_id=" +
                    this.cari.jabatan_id,
                { preserveScroll: true }
            );
        },
        reset() {
            this.cari = { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "" };
            this.search();
        },

        cetak() {
            window.location.href = this.service_pembayaran+'laporan/status/cetak?user_id='+this.auth.user.id+
            "&tarikh_dari=" +
            this.cari.tarikh_dari +
            "&tarikh_hingga=" +
            this.cari.tarikh_hingga +
            "&jabatan_id=" +
            this.cari.jabatan_id;
        },
    },
    watch: {},
    mounted() {
        // override default setting
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.tarikh_dari == "undefined") {
            this.cari.tarikh_dari = "";
        }
        if (this.cari.tarikh_hingga == "undefined") {
            this.cari.tarikh_hingga = "";
        }
        if (this.cari.jabatan_id == "undefined") {
            this.cari.jabatan_id = "";
        }
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
